<template>
  <!--
      作者：gmshop
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="出售中" name="sell"></el-tab-pane>
        <el-tab-pane label="库存紧张" name="stock"></el-tab-pane>
        <el-tab-pane label="已售罄" name="over"></el-tab-pane>
        <el-tab-pane label="已下架" name="lower"></el-tab-pane>
        <el-tab-pane label="草稿" name="draft"></el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" clearable placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品ID"><el-input size="small" v-model="searchForm.product_id" clearable placeholder="请输入商品ID"></el-input></el-form-item>
        <el-form-item label="商品名称"><el-input size="small" v-model="searchForm.product_name" clearable placeholder="请输入商品名称"></el-input></el-form-item>
        <el-form-item label="供货商ID"><el-input size="small" v-model="searchForm.supplier_id" clearable placeholder="请输入供货商ID"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">添加产品</el-button>
      <el-button size="small" type="primary" icon="el-icon-check" @click="openPopup('batch')"  v-auth="'/product/product/batch'">批量操作</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" ref="dragTable" border style="width: 100%" v-loading="loading" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
          <el-table-column prop="product_name" label="产品" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0].file_path" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                  <div class="name">ID：{{ scope.row.product_id }}</div>
                  <div class="name">供货商ID：{{ scope.row.supplier_id }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="category.name" label="分类"></el-table-column>
          <el-table-column prop="sales_actual" label="实际销量"></el-table-column>
          <el-table-column prop="product_stock" label="库存"></el-table-column>
          <el-table-column prop="view_times" label="点击数"></el-table-column>
          <el-table-column prop="product_status.text" label="状态">
            <template slot-scope="scope">
              <el-button @click="editStatus(scope, 1)" type="text" size="small" :style="scope.row.product_status.value == 10?'color:green':''">
              {{ scope.row.product_status.text }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="product_status.text" label="商品属性" width="170">
            <template slot-scope="scope">
              <el-button @click="editStatus(scope, 2)" type="text" size="small" :style="scope.row.is_new == 1?'color:green':''">
              新品
              </el-button>
              <el-button @click="editStatus(scope, 3)" type="text" size="small" :style="scope.row.is_hot == 1?'color:green':''">
              热卖
              </el-button>
              <el-button @click="editStatus(scope, 4)" type="text" size="small" :style="scope.row.is_recommend == 1?'color:green':''">
              推荐
              </el-button>
              <el-button @click="editStatus(scope, 5)" type="text" size="small" :style="scope.row.is_show == 1?'color:green':''">
              隐藏
              </el-button>
              <el-button @click="editStatus(scope, 6)" type="text" size="small" :style="scope.row.is_agri == 1?'color:green':''">
              农产品
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="product_status.text" label="商品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.is_virtual == 0">普通实物商品</span>
              <span v-if="scope.row.is_virtual == 1" class="green">虚拟商品</span>
              <span v-if="scope.row.is_virtual == 10" class="green">定制商品</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="发布时间"></el-table-column>
          <el-table-column prop="product_sort" label="排序"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/product/delete'">删除</el-button>
              <el-button @click="copyClick(scope.row)" type="text" size="small" v-auth="'/product/product/copy'">一键复制</el-button>
              <el-button @click="openPopup('copy', scope.row)" type="text" size="small">页面链接</el-button>
              <el-button @click="syncJushuitan(scope.row.product_id)" v-auth="'/product/product/syncJushuitan'"  type="text" size="small">同步erp</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :category="categoryList" :ids="batchIds" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>
    <!--页面链接-->
    <Copy v-if="show_popup['copy']" :is_open="show_popup['copy']" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'copy')"></Copy>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Batch from './batch';
import Copy from './copy';
export default {
  components: {
    Batch,
    Copy
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_id:'',
        product_name: '',
        category_id: '',
        supplier_id:'',
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      /*弹窗*/
      show_popup: {
        batch: false,
        copy: false,
      },
      dataModel:{},
      /*批量选中ids*/
      batchIds: [],
      product_status: null,
      is_new: null,
      is_hot: null,
      is_recommend: null,
      is_show: null,
      is_agri: null,
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    if (tabs) this.activeName = tabs;
    if (page) this.curPage = page;

    /*获取列表*/
    this.getData();
  },
  methods: {
    // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
    getRowKey (row) {
      return row.product_id;
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.batchIds = [];
      val.forEach(e => {
        this.batchIds.push(e.product_id);
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      // console.log(Params.category_id);
      // Params.category_id = Params.category_id[Params.category_id.length-1];
      self.loading = true;
      PorductApi.productList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.catgory;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      this.curPage = 1;
      this.getData();
      this.ids = [];
      this.$refs.dragTable.clearSelection();
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/product/product/add');
    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'edit'
        }
      });
    },
    syncJushuitan(product_id=0){
      let self = this;
      self.$confirm('确认同步吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.syncJushuitan({
            product_id: product_id
          }).then(res => {
            console.log(res)
            self.$message({
              message: res.msg,
              type: 'success'
            });
            self.getData();
          });
        });
    },

    /*产品状态转换*/
    editStatus(scope, e) {
      //状态
      if (e == 1) {
        if (scope.row.product_status.value == 10) {
          this.product_status = 20;
        }else if (scope.row.product_status.value == 20){
          this.product_status = 10;
        }
        if (this.product_status != null) {
          this.state(scope.$index, scope.row.product_id);
        }
      }
      //新品
      if (e == 2) {
        if (scope.row.is_new == 0) {
          this.is_new = 1;
        }else if (scope.row.is_new == 1){
          this.is_new = 0;
        }
        if (this.is_new != null) {
          this.state(scope.$index, scope.row.product_id);
        }
      }
      //热卖
      if (e == 3) {
        if (scope.row.is_hot == 0) {
          this.is_hot = 1;
        }else if (scope.row.is_hot == 1){
          this.is_hot = 0;
        }
        if (this.is_hot != null) {
          this.state(scope.$index, scope.row.product_id);
        }
      }
      //推荐
      if (e == 4) {
        if (scope.row.is_recommend == 0) {
          this.is_recommend = 1;
        }else if (scope.row.is_recommend == 1){
          this.is_recommend = 0;
        }
        if (this.is_recommend != null) {
          this.state(scope.$index, scope.row.product_id);
        }
      }
      //隐藏
      if (e == 5) {
        if (scope.row.is_show == 0) {
          this.is_show = 1;
        }else if (scope.row.is_show == 1){
          this.is_show = 0;
        }
        if (this.is_show != null) {
          this.state(scope.$index, scope.row.product_id);
        }
      }
      //隐藏
      if (e == 6) {
        if (scope.row.is_agri == 0) {
          this.is_agri = 1;
        }else if (scope.row.is_agri == 1){
          this.is_agri = 0;
        }
        if (this.is_agri != null) {
          this.state(scope.$index, scope.row.product_id);
        }
      }
    },

    state(index, product_id) {
      let self = this;
      self.$confirm('确认改变商品状态吗?', '提示', {
            type: 'warning'
          })
          .then(() => {
            PorductApi.state({
              product_id: product_id,
              product_status: this.product_status,
              is_new: this.is_new,
              is_hot: this.is_hot,
              is_recommend: this.is_recommend,
              is_show: this.is_show,
              is_agri: this.is_agri
            }).then(data => {
              this.tableData[index].product_status = data.data.model.product_status;
              this.tableData[index].is_new = data.data.model.is_new;
              this.tableData[index].is_hot = data.data.model.is_hot;
              this.tableData[index].is_recommend = data.data.model.is_recommend;
              this.tableData[index].is_show = data.data.model.is_show;
              this.tableData[index].is_agri = data.data.model.is_agri;
            });
          });
    },

    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'copy'
        }
      });
    },

    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },

    /*打开弹窗*/
    openPopup(name, item){
      this.dataModel = item;
      this.show_popup[name] = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.show_popup[f] = e.openDialog;
      if (e.type == 'success') {
        this.getData();
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/index.vue